// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import FastClick from 'fastclick'
import 'lib-flexible/flexible.js'
import vueWechatTitle from "vue-wechat-title"
import Vant from 'vant'
import 'vant/lib/index.css'
import vueHashCalendar from 'vue-hash-calendar'
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
import vView from 'vue-view-lazy'
const device = navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/)
if (!device || parseInt(device[1]) < 11) {
  FastClick.attach(document.body)
}
/* eslint-disable no-new */
Vue.use(vueWechatTitle)
Vue.use(Vant)
Vue.use(vueHashCalendar)
Vue.use(Vuex)
Vue.use(vView)
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js